/* GENERATED FILE — DO NOT EDIT.
 *
 * The Epley divisor, emitted from the Swift the phone compiles:
 *   HybridTrainer/Services/AI/AthleteEngineState.swift
 *     `EngineStateMath.bestE1RM` — weight × (1 + reps / 30.0)
 *   HybridTrainer/Services/AI/EngineTargetLoad.swift
 *     `EngineTargetLoad.targetWeightKg` — the same divisor, inverted
 *
 * Regenerate:  python3 tools/web-epley/emit.py
 *
 * ⚠️ IT IS EXTRACTED RATHER THAN TYPED BECAUSE TWO STATEMENTS OF ONE RULE IS THIS REPO'S DEFINING
 * BUG CLASS. If the engine changed the divisor and this were a hand-typed 30, the coach's chart
 * would keep drawing the old line and nothing anywhere would turn red. The generator also asserts
 * the FORWARD and the INVERSE agree — if they ever disagree that is an engine defect, and it
 * refuses rather than picking one.
 *
 * ⚠️ AND THE ESTIMATE'S KNOWN LIMIT TRAVELS WITH IT (the engine's own words): Epley DRIFTS above
 * roughly ten reps. On the coach's chart there is no inverse to cancel it, so a 15-rep set draws
 * an e1RM a few percent high. The chart says so rather than implying a precision it does not have.
 */

/** The divisor in `weight × (1 + reps / D)`. Extracted from Swift; see the header. */
export const EPLEY_DIVISOR = 30.0;

/** Above this many reps the estimate drifts high — the engine's own caveat, stated on the chart. */
export const EPLEY_RELIABLE_REPS = 10;

/**
 * The estimated one-rep max for one logged set, or null when the set cannot produce one.
 *
 * ⚠️ BOTH A LOAD AND COMPLETED REPS, OR NOTHING. A bodyweight set has no kg and a hold has no
 * reps; neither belongs in a table whose unit is kg, and inventing a zero for either is how a
 * chart grows a line nobody performed. The engine's `bestE1RM` guards the same two values.
 */
export function estimatedOneRepMax(weightKg: number | null, reps: number | null): number | null {
  if (weightKg === null || reps === null) return null;
  if (!(weightKg > 0) || !(reps > 0)) return null;
  return weightKg * (1 + reps / EPLEY_DIVISOR);
}
